import React, { useCallback, useState, useEffect } from 'react';
import axios from '@/data/http/axios';
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import DateTimeFunction from '@/Classes/dateTimeFunctions'
import i18n from '@/i18n'

export default function SentHistory({ CampaignId, SendingQueueId }) {
    const [loading, setLoading] = useState(true)
    const [history, setHistory] = useState(null)

    const getData = useCallback(async () => {
        const results = await axios.get('/campaign/' + CampaignId + '/stats/sent/' + SendingQueueId + '/history')
        setHistory(results.data)
    })

    useEffect(() => {
        if (history) {
            setLoading(false)
        }
    }, [history])

    useEffect(() => {
        getData()
    }, [])

    if (loading) return <LoadingIcons iconType="2" />

    let action = row.action;
    if(action == "received") {
        action = "queued"
    }

    const tableData = history.map(row => ({
        datetime: {
            headerValue: i18n.t('campaigns:overview.datetime'),
            value: DateTimeFunction.formatDateTime(row.date),
            orderBy: false
        },
        action: {
            headerValue: i18n.t('campaigns:overview.action'),
            value: action,
            orderBy: false,
        },
        data: {
            headerValue: i18n.t('campaigns:overview.details'),
            value: row.data,
            orderBy: false
        }
    }))

    return (
        <DataTable1
            noResultsTxt={<span> {i18n.t('noResults')}</span>}
            tableData={tableData}
            width="100%"
        />
    )
}